module.exports = __webpack_public_path__ + "img/96.10.pH.59715efe.png";